module.exports = __webpack_public_path__ + "static/media/banner_new_suppliers.ebbea89a.png";